import React from 'react';
import { Box, Typography } from '@mui/material';
import { LANDING_COLORS, LANDING_FONTS } from '../landingVisual';

const FlowStep = ({ stepNumber, title, description, isLast = false, vertical = false }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: vertical ? 'row' : 'column',
      alignItems: vertical ? 'flex-start' : 'center',
      textAlign: vertical ? 'left' : 'center',
      flex: vertical ? undefined : 1,
      position: 'relative',
      gap: vertical ? 2 : 0,
      fontFamily: LANDING_FONTS.sans,
    }}
  >
    <Box
      sx={{
        width: 44,
        height: 44,
        borderRadius: 1.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: LANDING_COLORS.ink,
        color: '#fff',
        fontWeight: 700,
        fontSize: '1rem',
        flexShrink: 0,
        mb: vertical ? 0 : 2,
        zIndex: 1,
        fontFamily: LANDING_FONTS.sans,
      }}
      aria-hidden="true"
    >
      {stepNumber}
    </Box>
    {!vertical && !isLast && (
      <Box
        sx={{
          display: { xs: 'none', md: 'block' },
          position: 'absolute',
          top: 22,
          left: 'calc(50% + 22px)',
          width: 'calc(100% - 44px)',
          height: 1,
          bgcolor: LANDING_COLORS.line,
          zIndex: 0,
        }}
      />
    )}
    <Box sx={{ flex: vertical ? 1 : undefined }}>
      <Typography
        variant="subtitle1"
        component="h3"
        sx={{ fontFamily: LANDING_FONTS.sans, fontWeight: 700, letterSpacing: '-0.01em', mb: 0.5 }}
      >
        {title}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontFamily: LANDING_FONTS.sans, lineHeight: 1.6 }}
      >
        {description}
      </Typography>
    </Box>
  </Box>
);

export default FlowStep;
